import React, { useContext, useEffect, useState } from "react";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import { TransitionContext } from "../../Context/TransitionContext";
import ChangePass from "./Setting/ChangePass";
import ShippingAddresses from "./Setting/ShippingAddresses";
import Notifications from "./Setting/Notifications";
import AccountBilling from "./Setting/AccountBilling";
import "./settings.css";
import { useLocation } from "react-router-dom";
import { getQueryParam, useScreenTransition } from "../../Hooks/useScreenTransition";

const TABS = ["shippping", "billing", "notification", "change-pass"];

const Setting = ({ windowSize }) => {

  const tab = getQueryParam("tab");
  const password = getQueryParam("pass");
  const { setColor } = useContext(TransitionContext);

  const [selectedTab, setSelectedTab] = useState(tab && TABS.includes(tab) ? tab : TABS[0]);

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  return (
    <>
      <AccountNavBar windowSize={windowSize} selectedTab="settings">
        <div className="accountMainTitleRow">
          <h2 className="accountMainTitle">Account Settings</h2>
        </div>
        <div className="accountSettingsMenu">
          <div className="accountSettingsMenuTab" onClick={() => setSelectedTab(TABS[0])}>
            <div className="accountSettingMenuTextWrap">
              <p className={`accountSettingMenuText ${selectedTab === TABS[0] && "selectedTab"}`}>Shipping Addresses</p>
            </div>
            <div className="accountSettingsMenuSpacer">
              <div />
            </div>
          </div>
          <div className="accountSettingsMenuTab" onClick={() => setSelectedTab(TABS[1])}>
            <div className="accountSettingMenuTextWrap">
              <p className={`accountSettingMenuText ${selectedTab === TABS[1] && "selectedTab"}`}>Billing</p>
            </div>
            <div className={`${windowSize.width > 849 ? "accountSettingsMenuSpacer" : ""}`}>
              <div />
            </div>
          </div>
          <div className="accountSettingsMenuTab" onClick={() => setSelectedTab(TABS[2])}>
            <div className="accountSettingMenuTextWrap">
              <p className={`accountSettingMenuText ${selectedTab === TABS[2] && "selectedTab"}`}>Notifications</p>
            </div>
            <div className="accountSettingsMenuSpacer">
              <div />
            </div>
          </div>
          <div className="accountSettingsMenuTab" onClick={() => setSelectedTab(TABS[3])}>
            <div className="accountSettingMenuTextWrap">
              <p className={`accountSettingMenuText ${selectedTab === TABS[3] && "selectedTab"}`}>Change Password</p>
            </div>
          </div>
        </div> 

        {selectedTab === TABS[0] && <ShippingAddresses windowSize={windowSize}/>}
        {selectedTab === TABS[1] && <AccountBilling windowSize={windowSize} />}
        {selectedTab === TABS[2] && <Notifications/>}
        {selectedTab === TABS[3] && <ChangePass password={password}/>}

        </AccountNavBar>
    </>
  );
};

export default Setting;
